module.exports = new __parcel__URL__("gallery_3.c48b82a3.jpg").toString();